import { bobby, cathy } from '@/config/endpointsConfig';

export const BOBBY_API_ROOT: string = `${bobby.url}${bobby.basePath}`;
export const CATHY_API_ROOT: string = `${cathy.url}${cathy.basePath}`;
